/* FB VIDEO — sikrer at autoplay-videoer faktisk koerer paa mobil.
   iOS starter ikke altid selv, saerligt efter en page transition eller
   naar videoen foerst kommer i syne. Vi kalder play() eksplicit og
   pauser det der er ude af skaermen, saa vi ikke braender batteri. */
(function () {
  'use strict';
  if (window.__fbVideoInit) return;
  window.__fbVideoInit = true;

  function selector() {
    return document.querySelectorAll(
      'video[autoplay].fb-hero__video, video[autoplay].fb-pdp__video, .fb-card__video video[autoplay]'
    );
  }

  function kick(video) {
    // Attributterne skal vaere sat i DOM'en, ikke kun i markup
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        // Browseren naegtede. Proev igen ved foerste beroering af siden.
        var retry = function () {
          video.play().catch(function () {});
          document.removeEventListener('touchstart', retry);
          document.removeEventListener('click', retry);
        };
        document.addEventListener('touchstart', retry, { once: true, passive: true });
        document.addEventListener('click', retry, { once: true });
      });
    }
  }

  function init() {
    var videos = selector();
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(kick);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            kick(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    videos.forEach(function (v) {
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Efter bfcache og efter theme-editor reload
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
})();
